var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("h3", { staticClass: "display-3" }, [
        _vm._v(_vm._s(_vm.title ? _vm.title : "Resource Not Found")),
      ]),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "subheading" },
        [
          _vm._v("\n    Sorry, we cannot find what you are looking for.\n    "),
          _c("br"),
          _vm._v(" "),
          _vm.badURL
            ? [
                _vm._v("\n      The URL\n      "),
                _c("b", [_vm._v("'" + _vm._s(_vm.badURL) + "'")]),
                _vm._v(" did not match any resource in the system.\n      "),
                _c("br"),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("v-divider", { staticClass: "mt-2" }),
      _vm._v(" "),
      _c("div", { staticClass: "subheading mb-2" }, [
        _vm._v("For support, please call 1-866-926-3261."),
      ]),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          staticClass: "mb-2",
          staticStyle: { margin: "0" },
          attrs: { color: "primary", large: "" },
          on: {
            click: function ($event) {
              return _vm.$router.push("/")
            },
          },
        },
        [
          _c("v-icon", { staticClass: "mr-1" }, [_vm._v("home")]),
          _vm._v(_vm._s(_vm.$t("App.Home")) + "\n  "),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }